var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ele-common-time',_vm._b({attrs:{"format":_vm.showFormat,"value":_vm.displayValue}},'ele-common-time',_vm.attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }